export default "__VITE_ASSET__BjyK_Arn__"